import { graphql } from 'relay-runtime';

export const progressCsvSkillQuery = graphql`
  query ProgressCsvSkillCsvQuery(
    $filter: AllSkillsFilterInput!
    $skip: Boolean = false
    $first: Int
    $after: String
    $last: Int
    $before: String
    $targetGroupsIds: [ID!]
  ) {
    allSkills(filter: $filter, first: $first, after: $after, last: $last, before: $before) @skip(if: $skip) {
      nodes {
        id
        name
        code
        targetSkills(filter: { targetGroupIds: $targetGroupsIds, isActive: ACTIVE }) {
          id
          target {
            id
            name
            targetGroup {
              id
              name
            }
          }
          targetSkillType {
            id
            name
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const progressSkillsResultsReport = graphql`
  query ProgressCsvResultsReportQuery($filter: SkillsProgressReportFilterInput!, $skip: Boolean = false) {
    skillsProgressReport(filter: $filter) @skip(if: $skip) {
      skill {
        id
      }
      skillsResults {
        key
        value
      }
    }
  }
`;
